// moz667: por culpa de vrdemo
var $ = jQuery;

// OJO: con el html del jquery.load no va a funcionar!!!!, es distinto a 
// cuando esta dentro del DOM. No obstante lo dejo por si fuera necesario
// para otras situaciones
window.activate_popovers = function (html) {
    var $obj = html !== undefined ? $(html) : $('body');

    $obj.find('[data-toggle="popover"]').each(function (e) {
        var $popover = $(this);
        if ($popover.data("content-selector")) {
            $popover.popover({
                trigger: $popover.data("trigger") ? $popover.data("trigger") : 'click',
                content: $($popover.data("content-selector")).html(),
                html: true
            });
        } else {
            $popover.popover();
        }
    });
}
